<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="ded">To Janis and Saul Bellow, <br/>for opening my world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780316076012_epub_ded_r1.vue?7fe1c6d9